import React from 'react'

import Base from '../_Base'

const CrMark48 = (props) => (
  <Base width="48" height="48" viewBox="0 0 48 48" {...props}>
    <g clipPath="url(#a)">
      <path d="M48 24C48 10.744 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24c.548 0 1.093-.02 1.63-.055C14.58 47.279 5.82 38.108 5.82 26.89c0-11.65 9.445-21.095 21.097-21.095 11.153 0 20.283 8.657 21.041 19.617.028-.467.042-.939.042-1.413Z" />
      <path d="M35.989 13.177a16.779 16.779 0 0 0-7.843-1.933c-9.316 0-16.866 7.551-16.866 16.865 0 9.315 7.55 16.866 16.866 16.866 9.314 0 16.866-7.55 16.866-16.866 0-1.055-.098-2.088-.285-3.09a7.678 7.678 0 1 1-8.739-11.841Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="none" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </Base>
)

export default CrMark48
